import React, { useState } from "react";
import { useFormikContext } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import SearchUom from "../../../inventory/items/searchUom";
import { DialogActions } from "@material-ui/core";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import SearchVendor from "../../../inventory/vendors/searchVendor";
import SearchItem from "../../../inventory/items/searchItem";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { formatDate } from "../../../../../utils/utils";
import { Card, Badge } from "react-bootstrap";
function AssetFormContent(props) {
  const { values, setFieldValue } = useFormikContext();
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [openSearchVendor, setOpenSearchVendor] = useState(false);
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [tab, setTab] = useState({
    ID: 4,
    title: "Assets",
    icon: "fab fa-dropbox",
  });
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [accountTypeID, setAccountTypeID] = useState(0);
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Asset Header</strong>
              </span>
              {values.ID !== "" ? (
                <React.Fragment>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.depreciationStatus === 3
                        ? "danger"
                        : values.depreciationStatus === 2
                        ? "warning"
                        : values.depreciationStatus === 1
                        ? "success"
                        : null
                    }
                  >
                    {values.depreciationStatus !== 0
                      ? "Asset " + values.depreciationStatusDesc
                      : null}
                  </Badge>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.disposalStatus === 3
                        ? "danger"
                        : values.disposalStatus === 2
                        ? "warning"
                        : values.disposalStatus === 1
                        ? "success"
                        : null
                    }
                  >
                    {values.disposalStatus !== 0
                      ? "Asset " + values.disposalStatusDesc
                      : null}
                  </Badge>
                </React.Fragment>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  {values.itemID > 0 ? (
                    <FormTextField
                      label="Asset Code"
                      name="assetCode"
                      iconField
                      iconOnStart={
                        values.itemType === 1
                          ? "fas fa-boxes"
                          : values.itemType === 2
                          ? "fas fa-tools"
                          : values.itemType === 3
                          ? "fas fa-building"
                          : values.itemType === 4
                          ? "fas fa-boxes"
                          : values.itemType === 5
                          ? "fas fa-boxes"
                          : ""
                      }
                      iconOnStartColor={
                        values.itemType === 1
                          ? "success"
                          : values.itemType === 2
                          ? "primary"
                          : values.itemType === 3
                          ? "info"
                          : values.itemType === 4
                          ? "warning"
                          : values.itemType === 5
                          ? "danger"
                          : ""
                      }
                      iconOnStartTooltip={values.itemTypeName}
                      readonly
                    />
                  ) : (
                    <FormTextField label="Asset Code" name="assetCode" />
                  )}
                  <FormTextField
                    label="Asset Name"
                    name="itemName"
                    searchButton={values.ID === 0 ? true : false}
                    clearButton={
                      values.itemID > 0 && values.ID === 0 ? true : false
                    }
                    readonly={values.itemID > 0 ? true : false}
                    onSearchClick={() => {
                      setOpenSearchItem(true);
                    }}
                    onClearFields={() => {
                      setFieldValue("itemID", 0);
                      setFieldValue("itemType", 0);
                      setFieldValue("itemTypeName", "");
                      setFieldValue("assetCode", "");
                      setFieldValue("itemName", "");
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      {values.ID === 0 ? (
                        <FormDateField
                          label="Purchase Date"
                          name="purchaseDate"
                        />
                      ) : (
                        <CustomOutlinedDisabledTextField
                          label="Purchase Date"
                          value={formatDate(values.purchaseDate)}
                        />
                      )}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      {values.ID === 0 ? (
                        <FormDateField
                          label="Received Date"
                          name="receivedDate"
                        />
                      ) : (
                        <CustomOutlinedDisabledTextField
                          label="Received Date"
                          value={formatDate(values.receivedDate)}
                        />
                      )}
                    </div>
                  </div>
                  {values.assetOriginType === 1 ? (
                    <React.Fragment>
                      <FormTextField
                        label="Vendor Name"
                        name="vendorName"
                        searchButton
                        clearButton
                        readonly
                        onSearchClick={() => {
                          setOpenSearchVendor(true);
                        }}
                        onClearFields={() => {
                          setFieldValue("vendorID", 0);
                          setFieldValue("vendorName", "");
                        }}
                      />
                    </React.Fragment>
                  ) : null}
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  {values.ID === 0 ? (
                    <React.Fragment>
                      <FormSelectField
                        label="Asset Origin"
                        name="assetOriginType"
                        onSelectChange={(value) => {
                          if (value === 1) {
                            setFieldValue(`incomeAccountID`, 0);
                            setFieldValue(`incomeAccountName`, "");
                          } else if (value === 2) {
                            setFieldValue(`cashAccountID`, 0);
                            setFieldValue(`cashAccountName`, "");
                          }

                          setFieldValue("unitPrice", 0);
                          setFieldValue("totalPrice", 0);
                        }}
                        options={[
                          { value: 1, label: "Purchase" },
                          { value: 2, label: "Other Income" },
                        ]}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CustomOutlinedDisabledTextField
                        label="Asset Origin"
                        value={values.assetOriginTypeName}
                      />
                    </React.Fragment>
                  )}
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      {values.ID === 0 ? (
                        <FormTextField
                          label="Quantity"
                          name="qty"
                          quantityField
                          onChangeValue={(value) => {
                            const unitDepAmount = parseFloat(
                              values.unitDepAmount
                            );
                            const unitPrice = parseFloat(values.unitPrice);
                            const qty = parseFloat(value);
                            setFieldValue("totalPrice", unitPrice * qty);
                            setFieldValue("unitValueAmount", unitPrice);
                            setFieldValue("totalValueAmount", unitPrice * qty);
                            setFieldValue(
                              "totalDepAmount",
                              unitDepAmount * qty
                            );
                          }}
                        />
                      ) : (
                        <CustomOutlinedDisabledTextField
                          label="Quantity"
                          value={values.qty}
                        />
                      )}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      {values.ID === 0 ? (
                        <FormTextField
                          label="Unit"
                          name="uomName"
                          searchButton
                          readonly
                          onSearchClick={() => {
                            setOpenSearchUom(true);
                          }}
                        />
                      ) : (
                        <CustomOutlinedDisabledTextField
                          label="Unit"
                          value={values.uomName}
                        />
                      )}
                    </div>
                  </div>
                  {values.assetOriginType === 1 ? (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Purchase Unit Price"
                            name="unitPrice"
                            currencyField
                            readonly={values.ID === 0 ? false : true}
                            onChangeValue={(value) => {
                              const unitPrice = parseFloat(value);
                              const qty = parseFloat(values.qty);
                              setFieldValue("totalPrice", unitPrice * qty);
                              setFieldValue("unitValueAmount", unitPrice);
                              setFieldValue(
                                "totalValueAmount",
                                unitPrice * qty
                              );
                            }}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Total Purchase Price"
                            name="totalPrice"
                            currencyField
                            readonly
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                  {values.ID === 0 ? (
                    <React.Fragment>
                      {values.assetOriginType === 1 ? (
                        <FormTextField
                          label="Cash Account"
                          name="cashAccountName"
                          searchButton
                          clearButton
                          onSearchClick={() => {
                            setAccountTypeID(1);
                            setOpenSearchGlAccount(true);
                          }}
                          onClearFields={() => {
                            setFieldValue(`cashAccountID`, 0);
                            setFieldValue(`cashAccountName`, "");
                          }}
                          readonly
                        />
                      ) : (
                        <FormTextField
                          label="Income Account"
                          name="incomeAccountName"
                          searchButton
                          clearButton
                          onSearchClick={() => {
                            setAccountTypeID(6);
                            setOpenSearchGlAccount(true);
                          }}
                          onClearFields={() => {
                            setFieldValue(`incomeAccountID`, 0);
                            setFieldValue(`incomeAccountName`, "");
                          }}
                          readonly
                        />
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {values.assetOriginType === 1 ? (
                        <CustomOutlinedDisabledTextField
                          label="Cash Account"
                          value={values.cashAccountName}
                        />
                      ) : (
                        <CustomOutlinedDisabledTextField
                          label="Income Account"
                          value={values.incomeAccountName}
                        />
                      )}
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <FormTextField
                    label="Asset Description"
                    name="assetDesc"
                    readonly={values.itemID > 0 ? true : false}
                    multiline
                    minRows={2}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
          <Card>
            <Card.Header>
              <i className="fas fa-money-bill-wave"></i>
              <span>
                <strong>Asset Value</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Unit Asset Value"
                        name="unitValueAmount"
                        currencyField
                        readonly={
                          values.ID === 0 && values.assetOriginType === 2
                            ? false
                            : true
                        }
                        onChangeValue={(value) => {
                          const qty = parseFloat(values.qty);
                          const totalAssetValue = parseFloat(value) * qty;
                          setFieldValue("totalValueAmount", totalAssetValue);
                        }}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Total Asset Value"
                        name="totalValueAmount"
                        currencyField
                        readonly
                      />
                    </div>
                  </div>
                  <FormTextField
                    label="Fixed Asset Account"
                    name="fixAssAccountName"
                    searchButton
                    clearButton
                    onSearchClick={() => {
                      setAccountTypeID(2);
                      setOpenSearchGlAccount(true);
                    }}
                    onClearFields={() => {
                      setFieldValue(`fixAssAccountID`, 0);
                      setFieldValue(`fixAssAccountName`, "");
                    }}
                    readonly
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <Card>
            <Card.Header>
              <i className="fas fa-money-bill-alt"></i>
              <span>
                <strong>Asset Depreciation</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Unit Depreciation Amount / Period"
                        name="unitDepAmount"
                        currencyField
                        onChangeValue={(value) => {
                          const qty = parseFloat(values.qty);
                          const totalDepAmount = parseFloat(value) * qty;
                          setFieldValue("totalDepAmount", totalDepAmount);
                        }}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Total Depreciation Amount / Period"
                        name="totalDepAmount"
                        readonly
                        currencyField
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Accumulated Depreciation Account"
                        name="accDepAccountName"
                        searchButton
                        clearButton
                        onSearchClick={() => {
                          setAccountTypeID(9);
                          setOpenSearchGlAccount(true);
                        }}
                        onClearFields={() => {
                          setFieldValue(`accDepAccountID`, 0);
                          setFieldValue(`accDepAccountName`, "");
                        }}
                        readonly
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Depreciation Expense Account"
                        name="depExAccountName"
                        searchButton
                        clearButton
                        onSearchClick={() => {
                          setAccountTypeID(10);
                          setOpenSearchGlAccount(true);
                        }}
                        onClearFields={() => {
                          setFieldValue(`depExAccountID`, 0);
                          setFieldValue(`depExAccountName`, "");
                        }}
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        fullScreen={false}
        maxWIdth="sm"
      >
        <SearchUom
          onSelectUom={(uom) => {
            setFieldValue("uomID", uom.ID);
            setFieldValue("uomName", uom.uomName);
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={accountTypeID}
          onSelectGlAccount={(account) => {
            switch (accountTypeID) {
              case 1:
                setFieldValue(`cashAccountID`, account.ID);
                setFieldValue(`cashAccountName`, account.accountName);
                break;
              case 5:
                setFieldValue(`inventoryAccountID`, account.ID);
                setFieldValue(`inventoryAccountName`, account.accountName);
                break;
              case 6:
                setFieldValue(`incomeAccountID`, account.ID);
                setFieldValue(`incomeAccountName`, account.accountName);
                break;
              case 2:
                setFieldValue(`fixAssAccountID`, account.ID);
                setFieldValue(`fixAssAccountName`, account.accountName);
                break;
              case 9:
                setFieldValue(`accDepAccountID`, account.ID);
                setFieldValue(`accDepAccountName`, account.accountName);
                break;
              case 10:
                setFieldValue(`depExAccountID`, account.ID);
                setFieldValue(`depExAccountName`, account.accountName);
                break;
              default:
                break;
            }

            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchVendor}
        title="Search Vendor"
        onCloseDialog={() => {
          setOpenSearchVendor(false);
        }}
        maxWIdth="md"
      >
        <SearchVendor
          onSelectVendor={(vendor) => {
            setFieldValue("vendorID", vendor.ID);
            setFieldValue("vendorName", vendor.vendorName);
            setOpenSearchVendor(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchVendor(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchItem}
        title="Search Item"
        onCloseDialog={() => {
          setOpenSearchItem(false);
        }}
        minHeight={true}
      >
        <SearchItem
          tab={tab}
          selectSellableItems={false}
          selectServiceItems={false}
          selectItemPackages={false}
          selectAssetItems={true}
          onSelectItem={(item, itemPackage, varCode, valueName) => {
            setFieldValue("itemID", item.ID);
            setFieldValue("itemType", item.itemType);
            setFieldValue("itemTypeName", item.itemTypeName);
            setFieldValue("assetCode", item.itemCode);
            setFieldValue("itemName", item.itemName);
            setFieldValue("assetDesc", item.itemDesc);
            setOpenSearchItem(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItem(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default AssetFormContent;
